<template>
  <validation-observer
    id="stepIntroForm"
    ref="form"
    tag="form"
    novalidate
    @submit.prevent="handleSubmit"
    style="max-width: 338px; margin: 0 auto;"
  >
    <vvs-control-wrapper label="1. Sözleşme Bilgileri"></vvs-control-wrapper>

    <vvs-general-checkbox
      name="Sözleşme Kabulu"
      label="Sözleşme Kabulu"
      :validate="{ required: { allowFalse: false } }"
    >
      <div class="vvns-checkbox__content">
        <a
          :href="contractUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="vvns-checkbox__link"
        >
          Tedarikçi Sözleşmesi,<br />Tedarikçi Cari Kartı,Kişisel Verilerin
          Korunmasına İlişkin Taahhütname
        </a>
        <span class="vvns-checkbox__text">
          sözleşmesini okudum onaylıyorum</span
        >
      </div>
    </vvs-general-checkbox>

    <vvs-control-wrapper label="2. Banka Bilgileri"></vvs-control-wrapper>

    <vvs-input
      name="Banka Adı"
      label="Banka Adı"
      validate="required|withoutEmoji|max:255"
      v-model="form.bankAccounts[0].name"
    >
    </vvs-input>

    <vvs-input
      name="IBAN"
      label="IBAN"
      validate="required|min:32"
      validate-mode="lazy"
      placeholder="TR__ ____ ____ ____ ____ ____ __"
      mask="TR## #### #### #### #### #### ##"
      v-model="form.bankAccounts[0].iban"
    ></vvs-input>

    <vvs-control-wrapper
      label="3. Şirket evraklarınızı yükleyin:"
    ></vvs-control-wrapper>

    <vvs-uploader
      name="Vergi Lehvası"
      label="Vergi Lehvası"
      validate="required"
      v-model="form.taxMedias"
      normal-label
    ></vvs-uploader>

    <vvs-uploader
      name="İmza Sirküleri"
      label="İmza Sirküleri"
      validate="required"
      v-model="form.signatureCircularMedias"
      normal-label
    ></vvs-uploader>

    <vvs-uploader
      name="Ticari sicil kaydı"
      label="Ticari sicil kaydı"
      validate="required"
      v-model="form.commercialRegistrationMedias"
      normal-label
    ></vvs-uploader>

    <vvs-uploader
      name="Oda kayıt belgesi"
      label="Oda kayıt belgesi"
      validate="required"
      v-model="form.chamberRegistrationMedias"
      normal-label
    ></vvs-uploader>

    <vvs-recaptcha
      v-if="showRecaptcha"
      name="Google Recaptcha"
      validate="required"
      v-model="googleVerifyKey"
    ></vvs-recaptcha>

    <vvs-submit-button
      title="BAŞVURUYU TAMAMLAYIN"
      description="* doldurulması zorunlu alan"
    ></vvs-submit-button>
  </validation-observer>
</template>

<script>
import stepsMixin from './../steps.mixin';

export default {
  name: 'StepContract',
  mixins: [stepsMixin],
  data() {
    return {
      contractUrl: process.env.VUE_APP_SUPPLIER_CONTRACT_URL,
    };
  },
};
</script>
